import { a as e } from "./index828.mjs";
var t = e, s = function() {
  var a = t(this), i = "";
  return a.hasIndices && (i += "d"), a.global && (i += "g"), a.ignoreCase && (i += "i"), a.multiline && (i += "m"), a.dotAll && (i += "s"), a.unicode && (i += "u"), a.unicodeSets && (i += "v"), a.sticky && (i += "y"), i;
};
export {
  s as r
};
